import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuNav, MenuCategory } from './MenuNav';
import { Kebabs } from './Kebabs';
import { BakedPotatoes } from './BakedPotatoes';
import { Extras } from './Extras';
import { Drinks } from './Drinks';
const CATEGORY_CONTENT: Record<MenuCategory, React.ReactNode> = {
  kebabs: <Kebabs data-id="element-104" />,
  papas: <BakedPotatoes data-id="element-105" />,
  extras: <Extras data-id="element-106" />,
  bebidas: <Drinks data-id="element-107" />
};
export function MenuSection() {
  const [active, setActive] = useState<MenuCategory>('kebabs');
  return <>
      <MenuNav active={active} onChange={setActive} data-id="element-108" />

      {/* Single content zone — only the active category renders here.
            The page does not scroll; content swaps in place with a soft fade. */}
      <div className="w-full bg-bp-bg" data-id="element-109">
        <AnimatePresence mode="wait" data-id="element-110">
          <motion.div key={active} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2,
          ease: 'easeInOut'
        }} data-id="element-111">
            {CATEGORY_CONTENT[active]}
          </motion.div>
        </AnimatePresence>
      </div>
    </>;
}